import React from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import { Input } from 'widget/components';

interface PhoneNumber {
  style: React.CSSProperties;
}

const PhoneNumber = ({ style }: PhoneNumber) => {
  const [field, meta, helpers] = useField<string>('phone_number');
  const { t } = useTranslation();

  const isValid = !(meta.error && meta.touched);

  return (
    <Input
      {...field}
      isValid={isValid}
      onChange={helpers.setValue}
      placeholder={t`Your phone number`}
      style={style}
      type="tel"
    />
  );
};

export default PhoneNumber;
